export const EXANDRIA_TYPE = 'db';
export const GOOGLE_TYPE = 'google';
